import { TableCell } from "@mui/material";
import type { JSX, ReactNode } from "react";

/** Uppercase table-header cell for the pending-approval queue. Extracted from
 * `PendingApprovalTable.tsx`. */
export function HeadCell({
  children,
  align = "left",
  sx,
}: {
  children: ReactNode;
  align?: "left" | "right";
  sx?: object;
}): JSX.Element {
  return (
    <TableCell
      sx={{
        px: 1,
        py: 1,
        borderColor: "divider",
        fontSize: 10,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.14em",
        color: "text.secondary",
        textAlign: align,
        ...sx,
      }}
    >
      {children}
    </TableCell>
  );
}
